import { render } from "./SaveDialogRange.vue?vue&type=template&id=006a0262&scoped=true"
import script from "./SaveDialogRange.vue?vue&type=script&lang=js"
export * from "./SaveDialogRange.vue?vue&type=script&lang=js"

import "./SaveDialogRange.vue?vue&type=style&index=0&id=006a0262&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-006a0262"

export default script